export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const MONTH_NAMES_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const DAY_NAMES_SHORT = [
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
];

export const ordinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
};

export const parseDate = (raw) => {
  if (raw == null || raw === "") return null;
  if (raw instanceof Date) return Number.isNaN(raw.getTime()) ? null : raw;
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d;
};

// e.g. `24th July 2026`
export const formatLongDate = (raw) => {
  const d = parseDate(raw);
  if (!d) return "";
  return `${ordinal(d.getDate())} ${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`;
};

// e.g. `24 Jul 2026`
export const formatShortDate = (raw) => {
  const d = parseDate(raw);
  if (!d) return "";
  return `${d.getDate()} ${MONTH_NAMES_SHORT[d.getMonth()]} ${d.getFullYear()}`;
};

// e.g. `Monday`
export const formatDayName = (raw) => {
  const d = parseDate(raw);
  if (!d) return "";
  return DAY_NAMES[d.getDay()];
};

// e.g. `Mon`
export const formatDayNameShort = (raw) => {
  const d = parseDate(raw);
  if (!d) return "";
  return DAY_NAMES_SHORT[d.getDay()];
};